// AdminBranchView/index.js
import { connect } from 'react-redux';
import AdminBranchView from '../../components/AdminBranchView';

import {
  fetchUserDetailsDispatch,
  setLoggedInUserDispatch,
  checkBranchAccessForUserDispatch
} from '../../actions';

function mapStateToProps(state, ownProps) {
  return {
    userFromDb: state.users.user.item
  };
}

function mapDispatchToProps(dispatch, ownProps) {
  return {
    fetchUserDetails: (userEmail) => {
      dispatch(fetchUserDetailsDispatch(userEmail));
    },
    setLoggedInUser: (user) => {
      dispatch(setLoggedInUserDispatch(user));
    },
    checkBranchAccessForUser: (userId, branchId) => {
      const payload = { userId, branchId };
      dispatch(checkBranchAccessForUserDispatch(payload));
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminBranchView);
